<template>
    <div v-if="task.output" style="text-align: right">
        <a :href="task.output.csvUrl" v-if="task.output.csvUrl" target="_blank" class="btn blue" @click="done">
            <i class="fa fa-download"></i>
            Baixar arquivo CSV
        </a>
        <a :href="task.output.xlsxUrl"  v-if="task.output.xlsxUrl" target="_blank" class="btn blue" v-tooltip title="Excel 2007 ou superior" @click="done">
            <i class="fa fa-download"></i>
            Baixar arquivo Excel
        </a>
        <a :href="task.output.jsonUrl" v-if="task.output.jsonUrl" target="_blank" class="btn blue" @click="done">
            <i class="fa fa-download"></i>
            Baixar arquivo JSON
        </a>
        <a :href="task.output.xmlUrl" v-if="task.output.xmlUrl" target="_blank" class="btn blue" @click="done">
            <i class="fa fa-download"></i>
            Baixar arquivo XML
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            },
            done: {
                type: Function
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ExportPropertiesV1.vue?6780cfe4